module.exports = __webpack_public_path__ + "img/Flaticon.c1729513.svg";